import Vue from 'vue'
import Vuex from 'vuex'

import auth from './module/auth'
import csv from './module/csv'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        auth,
        csv
    }
})

export default store